export enum TrusteePreference {
  HIDDEN_FOLDER_REGEXP = 'HIDDEN_FOLDER_REGEXP',
  CUSTOMER_CONTACT_EMAIL_ADDRESS = 'CUSTOMER_CONTACT_EMAIL_ADDRESS',

}
